import { playSound } from './playSound';
import { getConfigForSoundName } from './getConfigForSoundName';
export const playBatchSounds = (audioContext, soundName) => {
  const configs = getConfigForSoundName(soundName);
  const stopFunctions = configs.map(config => playSound(audioContext, config));
  const stop = () => {
    stopFunctions.forEach(stopFunction => {
      stopFunction();
    });
  };
  return stop;
};